<template>
    <sa-page-layout :btnBackVisible="true" :linkback="linkback" :pathResource="pathResource">
        <template slot="toolbar-title">
            <rsa-ospite-anagrafica-component :jsonData="jsonData"></rsa-ospite-anagrafica-component>
        </template>
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="3" lg="4" xl="4">
                        <label class="sa-label-data">Tipo:</label>
                        <b-form-select v-model="filtroSchedeValutazione.tipologia" type="search" id="tipoScale" placeholder="Inserire tipo scala" :options="tipologiaSchedaOptions">
                            <template #first>
                                <b-form-select-option :value="null">- Seleziona Tipo Scheda - </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="3" lg="4" xl="4">
                        <label class="sa-label-data">Data dal:</label>
                        <date-picker v-model="filtroSchedeValutazione.dataDal" format="DD-MM-YYYY" value-type="timestamp" placeholder="Seleziona data iniziale" type="date"> </date-picker>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="3" lg="4" xl="4">
                        <label class="sa-label-data">Data al:</label>
                        <date-picker v-model="filtroSchedeValutazione.dataAl" format="DD-MM-YYYY" value-type="timestamp" placeholder="Seleziona data finale" type="date"> </date-picker>
                    </b-col>
                </b-row>
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
                        <b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template>
        <template slot="table-body">
            <rsa-paziente-schede-valutazione-list-component ref="cmpRsaPazienteSchedeValutazioneList"></rsa-paziente-schede-valutazione-list-component>
        </template>
    </sa-page-layout>
</template>

<script>
import axios from "axios";
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaOspiteAnagraficaComponent from "../../rsagestioneospiti/components/RsaOspiteAnagraficaComponent.vue";
import RsaPazienteSchedeValutazioneListComponent from "../components/RsaPazienteSchedeValutazioneListComponent.vue";
import DatePicker from "vue2-datepicker";
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
    props: {
        utente: { type: Object },
    },
    components: {
        SaPageLayout,
        RsaOspiteAnagraficaComponent,
        RsaPazienteSchedeValutazioneListComponent,
        DatePicker,
    },
    data() {
        return {
            idAccettazione: null,
            btnNuovaRichiestaEsameHidden: true,
            btnNuovaRichiestaUscita: true,
            filtro: {},
            btnNewVisible: true,
            pathResource: "/rsaschedevalutazionepazientetestata",
            pathResourceAccettazione: "/accettazioni",
            linkback: "/rsagestioneospiti",
            listKey: 0,
            filtroSchedeValutazione: { tipologia: null, dataDal: null, dataAl: null },
            jsonData: { accettazioneAnagrafica: {}, accettazionePrestazioni: {}, accettazioneStati: [], accettazioneStruttura: {}, accettazionePresidio: {} },
            tipologiaSchedaOptions: [],
        };
    },
    mounted() {
        let me = this;
        me.idAccettazione = this.$route.query.idAccettazione;
        let sessionStorage = window.sessionStorage;
        if (sessionStorage["filtroSchedeValutazione"]) {
            me.filtroSchedeValutazione = JSON.parse(sessionStorage["filtroSchedeValutazione"]);
        }
        me.loadTipologieSchedeValutazione();
        me.loadAccettazione();
    },
    methods: {
        loadAccettazione() {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceAccettazione + "/" + me.idAccettazione;
            axios
                .get(link)
                .then((response) => {
                    me.jsonData = response.data.data;
                    me.$refs.cmpRsaPazienteSchedeValutazioneList.init(me.jsonData);
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        loadTipologieSchedeValutazione() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResource + "/tipologie", { idAccettazione: me.idAccettazione }, me.resultResponseTipologieSchede, me.resultErrorTipologieSchede);
        },
        resultResponseTipologieSchede(response) {
            let me = this;
            response.data.data.forEach((element) => {
                me.tipologiaSchedaOptions.push({ text: element.tipologia, value: element.tipologia });
            });
        },
        resultErrorTipologieSchede(error) {
            console.log(error);
        },
        onUpdateTipologieschede(array) {
            console.log(array);
        },
        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroSchedeValutazione"] = JSON.stringify(me.filtroSchedeValutazione);
            me.$refs.cmpRsaPazienteSchedeValutazioneList.init(me.jsonData);
        },
        onReset() {
            let me = this;
            me.filtroSchedeValutazione = { tipologia: null, dataDal: null, dataAl: null };
            sessionStorage["filtroSchedeValutazione"] = JSON.stringify(me.filtroSchedeValutazione);
            me.$refs.cmpRsaPazienteSchedeValutazioneList.init(me.jsonData);
        },
    },
};
</script>

<style></style>
